// @ts-ignore
const AngularApp = window.angular.element(document.querySelector('#zApp'));

export function angularService(serviceName) {
    return AngularApp.injector().get(serviceName);
}

export function angularEmit(eventName, data = {}) {
    return AngularApp.scope().$emit(eventName, data);
}

export function angularBroadcast(eventName, data = {}) {
    return AngularApp.scope().$broadcast(eventName, data);
}

export function angularEventOn(eventName, callback) {
    return  AngularApp.scope().$on(eventName, callback);
}

export function getCompiledDirective(directiveString) {
    const injector = AngularApp.injector();
    const compiled = injector.invoke(
        ['$rootScope', '$compile', ($rootScope, $compile) => {
            return $compile(directiveString)($rootScope);
        }]
    );
    return compiled;
}
